import { LOGO_URL } from "@/components/Logo";

/**
 * Elegant mobile app header — pinned top, logo + optional right slot.
 * Use over a map: pair with a separate glass card below.
 */
export default function MobileBrandHeader({ subtitle = "ENEC Transport", rightSlot = null, testId = "mobile-brand-header" }) {
  return (
    <div
      data-testid={testId}
      className="pt-safe px-4 pt-3 pb-2 flex items-center justify-between"
      style={{
        background: "linear-gradient(180deg, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0.55) 70%, rgba(255,255,255,0) 100%)",
        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",
      }}
    >
      <div className="flex items-center gap-2.5">
        <img src={LOGO_URL} alt="TESLAM" className="h-9" />
        <p className="text-[10px] uppercase tracking-[0.22em] text-slate-500 font-bold">{subtitle}</p>
      </div>
      {rightSlot}
    </div>
  );
}
